import { camelCase, capitalCase, pascalCase, paramCase, snakeCase } from 'change-case';
import { upperCase } from 'upper-case';
import { lowerCase } from 'lower-case';
export {
	camelCase,
	capitalCase,
	pascalCase,
	paramCase,
	upperCase,
	lowerCase,
	capitalCase as titleCase, // title case has been replaced by capital case (title-case library works differently)
	snakeCase,
};